// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2hwx1i6y{margin-right:var(--ds-space-negative-025,-2px)}", ""]);
// Exports
module.exports = exports;
